/**
 * Offer the trip link only while it leads to a public trip page (interest page,
 * fundraising page, or trip journal). The server decides, so a leader never
 * copies or prints a link that is dead at that moment.
 */
export function showPublicTripLink(
  trip: { hasPublicTripPage?: boolean } | null | undefined,
): boolean {
  return trip?.hasPublicTripPage === true;
}
